export default (client, defaultParams) => ({
  get: (hash) => (
    client(`/giftcard/${hash}`, {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  all: () => (
    client('/giftcards', {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  update: (hash, data) => (
    client(`/giftcard/${hash}`, {
      method: 'PUT',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),
  sendReceiverEmail: (hash, email) => (
    client(`/giftcard/${hash}/send_receiver_email`, {
      method: 'PUT',
      data: { email },
      params: {
        ...defaultParams,
      },
    })
  ),
  create: (data) => (
    client('/giftcards', {
      method: 'POST',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
